<script>
import Notification from "../reUse/Notification.vue";
import { i18n } from '@/i18n'
import sl from "@/Prevodi/BrisanjeRacuna-sl.json";
import en from "@/Prevodi/BrisanjeRacuna-en.json";
import it from "@/Prevodi/BrisanjeRacuna-it.json";
export default {
  components: {
    Notification,
  },
  props: {
    UserID: String,
    FullUser: Object,
  },
  emits: ['izpisUporabnika'],
  mounted() {
    this.BeriPilote();
  },
  data() {
    return {
      showSettings: false,
      prevodi: false,
      piloti: [],
      /* OBVESTILA */
      ShowNoti: false,
      text: '',
      types: '',
    }
  },
  created() {
    // await this.loadTranslations('sl', './src/prevodi/BrisanjeRacuna-sl.json');
    // await this.loadTranslations('en', './src/prevodi/BrisanjeRacuna-en.json');
    // await this.loadTranslations('it', './src/prevodi/BrisanjeRacuna-it.json');
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  methods: {
    BeriPilote() {
      axios.get('./api/sifranti/piloti/izpis/', {withCredentials: true}).then((response) => {
        this.piloti = response.data.piloti.filter(pilot => pilot.email === this.FullUser.email);
      }).catch((napaka) => {
        this.text = napaka;
        this.types = "Napaka";
        this.ShowNoti = true;
      })
    },
    OpenSettings() {
      this.showSettings = !this.showSettings;
    },
    PotrdiIzbris() {
      if (!this.piloti.length > 0) {
        this.text = this.$t('labelsRacun.napakaPilota');
        this.types = "Napaka";
        this.ShowNoti = true;
      } else {
        this.text = this.$t('labelsRacun.potrdiIzbris');
        this.types = "Vprašanje";
        this.ShowNoti = true;
      }
    },
    Izbrisi() {
      var podatki = new URLSearchParams();
      podatki.append('id_brisanja', this.piloti[0].id);
      axios.post('./api/sifranti/piloti/brisi/', podatki, {withCredentials: true}).then((response) => {
        this.text = this.$t('labelsRacun.potrjenIzbris');
        this.types = "Uspešno";
        this.ShowNoti = true;
        setTimeout(() => {
          this.$emit('izpisUporabnika');
        }, 10000);

      }).catch((napaka) => {
        this.text = this.$t('labelsRacun.napakaIzbrisa');
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
  }
}
</script>
<template>
  <!--       <div class="drop-down-icon text-black" @click.prevent="OpenSettings()">
          <i v-show="!showSettings" class="fas fa-chevron-right"></i>
          <i v-show="showSettings" class="fas fa-chevron-down"></i>
      </div>
      <button class="btn-prikaz-povzetka border-0 rounded-4 p-2 fs-5" type="text" id="Skupno" @click.prevent="OpenSettings()">{{$t('labelsRacun.buttons.odpri')}}</button> -->
  <transition name="fade">
    <div class='modern-section-body mt-2'>
      <!-- OPOZORILO -->
      <div class="modern-form-group">
        <span class='text-danger'>{{$t('labelsRacun.opozorilo')}}</span>
      </div>
      <div class="modern-form-actions">
        <button class="modern-btn modern-btn-danger" @click.prevent="PotrdiIzbris()">
          <i class="fas fa-trash"></i>
          {{$t('labelsRacun.buttons.izbrisi')}}
        </button>
      </div>
    </div>
  </transition>
  <Transition name="fade">
    <Notification class="top-0" v-if="ShowNoti" :message="this.text" :type="this.types"  @da="Izbrisi()" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
  </Transition>
</template>